document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pk-pincode]').forEach(initPincodeGate);
});

function initPincodeGate(root) {
  var input = root.querySelector('[data-pk-pincode-input]');
  var button = root.querySelector('[data-pk-pincode-check]');
  var status = root.querySelector('[data-pk-pincode-status]');
  var allowed = (root.dataset.pincodes || '')
    .split(',')
    .map(function (c) { return c.trim(); })
    .filter(Boolean);

  var section = root.closest('section') || document;
  var gateButtons = section.querySelectorAll('[data-pk-gate-button]');

  function setGated(isUnlocked) {
    gateButtons.forEach(function (btn) {
      btn.disabled = !isUnlocked;
      btn.classList.toggle('pk-is-locked', !isUnlocked);
    });
    section.querySelectorAll('[data-pk-gate-required]').forEach(function (el) {
    el.hidden = isUnlocked;
  });
  }

  function showStatus(ok) {
    status.textContent = ok ? root.dataset.successMsg : root.dataset.failMsg;
    status.classList.toggle('pk-pincode__status--ok', ok);
    status.classList.toggle('pk-pincode__status--fail', !ok);
  }

  function check() {
    var value = (input.value || '').trim();
    if (!/^\d{6}$/.test(value)) {
      status.textContent = 'Enter a valid 6-digit pincode.';
      status.classList.remove('pk-pincode__status--ok', 'pk-pincode__status--fail');
      setGated(false);
      return;
    }
    var ok = allowed.indexOf(value) !== -1;
    showStatus(ok);
    setGated(ok);
    try {
      localStorage.setItem('pk_pincode', JSON.stringify({ pincode: value, ok: ok }));
    } catch (e) {}
  }

  button.addEventListener('click', check);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      check();
    }
  });

  setGated(false);

  try {
    var saved = JSON.parse(localStorage.getItem('pk_pincode') || 'null');
    if (saved && saved.pincode) {
      input.value = saved.pincode;
      var stillOk = allowed.indexOf(saved.pincode) !== -1;
      showStatus(stillOk);
      setGated(stillOk);
    }
  } catch (e) {}
}